<template>
  <span
    class="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "WarningBadge",
  props: ["label"],
};
</script>
